// extracted by mini-css-extract-plugin
export var container = "_n9-0";
export var dotAnimation = "_n9-2";
export var dotsLoading = "_n9-1";